import { render } from "./AssessementDescription.vue?vue&type=template&id=27717dd7"
import script from "./AssessementDescription.vue?vue&type=script&lang=js"
export * from "./AssessementDescription.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__